function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLanguageAndLiterature = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M34.043,2.062C32.506,0.525 30.021,0.525 28.484,2.062L26.371,4.168L33.243,11.039L35.355,8.926C36.892,7.389 36.892,4.905 35.355,3.368L34.043,2.062ZM13.043,17.503C12.615,17.931 12.285,18.458 12.096,19.04L10.018,25.273C9.815,25.876 9.976,26.543 10.425,26.999C10.875,27.455 11.541,27.61 12.152,27.406L18.384,25.329C18.96,25.132 19.486,24.809 19.921,24.381L31.663,12.632L24.785,5.754L13.043,17.503ZM7.681,5.031C3.961,5.031 0.943,8.049 0.943,11.769L0.943,29.736C0.943,33.456 3.961,36.474 7.681,36.474L25.649,36.474C29.368,36.474 32.386,33.456 32.386,29.736L32.386,22.999C32.386,21.756 31.383,20.753 30.14,20.753C28.898,20.753 27.894,21.756 27.894,22.999L27.894,29.736C27.894,30.979 26.891,31.982 25.649,31.982L7.681,31.982C6.439,31.982 5.435,30.979 5.435,29.736L5.435,11.769C5.435,10.527 6.439,9.523 7.681,9.523L14.419,9.523C15.661,9.523 16.665,8.519 16.665,7.277C16.665,6.035 15.661,5.031 14.419,5.031L7.681,5.031Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLanguageAndLiterature);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/language-and-literature.1d5c24f965c5b37a3dd1cfbde63fb4f3.svg";